export default __webpack_public_path__ + "static/media/mf0.3936d30e.jpg";